import * as React from "react";
import { ChoiceList } from "@cmsgov/design-system-core";
import {
  filterChoices,
  addCheckedToSelectedOption,
} from "../../common/services/Filters";

export interface Props {
  selectedReport: string;
  previousReport: string;
  selectedStartDate: string;
  selectedEndDate: string;
  selectedStates: string[];
  previousLocations: string[];
  onChange: (
    selectedReport: string,
    previousReport: string,
    selectedStartDate: string,
    selectedEndDate: string,
    selectedStates: string[],
    previousLocations: string[],
  ) => void;
}
function SelectReport({
  selectedReport,
  previousReport,
  selectedStartDate,
  selectedEndDate,
  selectedStates,
  previousLocations,
  onChange,
}: Props) {
  const choiceChanged = (event: any) => {
    onChange(
      event.target.value,
      previousReport,
      selectedStartDate,
      selectedEndDate,
      selectedStates,
      previousLocations,
    );
  };
  const choices = addCheckedToSelectedOption(
    filterChoices.selectedReport,
    selectedReport,
  );
  return (
    <ChoiceList
      choices={choices}
      label="Choose a Report"
      name="chooseReport"
      type="select"
      onChange={choiceChanged}
    />
  );
}

export default SelectReport;
